import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'
import PageTransition from 'gatsby-plugin-page-transitions';
import ReactDOM from 'react-dom'

import { Block, Section } from '../components'

import { fetchSettings, getSettings } from '../store/settings'

import { pageTransitionProps } from '../utils'
import { themes } from '../styles/themes'
import { container, heading, bgImage, button, bgIcon } from "../styles/global"
import logo from '../assets/images/logo.svg'
import { media, isClient } from "../styles/utils";

class Home extends Component {

	state = {
		sections: [],
	}

	componentWillMount = () => {
		this.props.fetchSettings()
	}
	    
	componentDidMount = () => {
        const { settings } = this.props;
        const data = this.props.data.wordpressHome;
        
		this.setState({
			sections: JSON.parse(data.acf_json).sections,
            pageLoaded: true,
        })        
    }
  
	renderBlocks = (blocks) => {
		return blocks.map((block, i) => {                
			return (
				<Block
					layout={block.acf_fc_layout}
					key={i}
					{...block}
				/>
			)
		})
	}

	renderSections = () => {
		const { sections } = this.state;

		return sections.map((section, i) => {
			const blocks = section.blocks;
            
			if (section.display_section && section.blocks) {
				return (
					<Section
						key={i}
						blocks={blocks}
						section={section}
					/>
				)
			}
		})
	}

  	render() {
		const { pageLoaded } = this.state;
		const splashActive = this.props.settings.splashActive;
		
		return (
			<React.Fragment>
				<PageTransition
					{...pageTransitionProps}
				>	
					<Wrapper
                        active={splashActive == false}
					>
						{this.renderSections()}		
					</Wrapper>
				</PageTransition>
			</React.Fragment>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;
	transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
	transform: translateY(100px);
	opacity: 0;

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`

const Container = styled.div`
    ${container}
	display: flex;
	flex-direction: column;
`

// Shared

const Heading = styled.div`
	${heading}
`
const Description = styled.div``

// Hero

const Splash = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgb(228, 231, 235);
	z-index: 13;
	display: flex;
	justify-content: center;

	${Container} {
		height: 100%;
		justify-content: center;
		align-items: center;
	}

	/* Animation */

	opacity: 0;
	pointer-events: none;
	transition: opacity 0.75s ease-out;

	${props => {
		if (props.active) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}

	/* Theme */

	${props => {
		if (props.theme) {
			const theme = themes[props.theme];
			return css`
				background: ${theme.background};

				${Heading} {
					color: ${theme.text}
				}
			`
		}
	}}
`

const Logo = styled.div`
	background-image: url(${logo});
	width: 374px;
	height: 40px;
	${bgIcon}

	${media.tablet`
		height: 30px;
	`}
`

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Home);

// Set here the ID of the home page.

export const pageQuery = graphql`
	query Home {
		wordpressHome {
			acf_json
		}
	}
`


// WEBPACK FOOTER //
// ./src/pages/index.js